import axios from 'axios';
import Qs from "qs";

export default {

    install(app, http) {

        const clients = {};

        const createClient = (url) => axios.create({
            baseURL: url,
            validateStatus: function (status) {
                return (status >= 200 && status < 300) || (status >= 400 && status < 500);
            },
            paramsSerializer: function (params) {
                return Qs.stringify(params, {arrayFormat: 'brackets'})
            }
        });

        Object.entries(http).forEach(([name, {url}]) => {
            clients[name] = createClient(url);
        });

        if (!clients.vault && http.default?.url) {
            clients.vault = createClient(new URL('/', new URL(http.default.url, window.location.origin)).href);
        }


        app.provide('$http', this);
        app.config.globalProperties.$http = {
            clients,
            refreshHandler: null,
            header(name, header, value) {
                if (value === null || value === undefined) {
                    delete this.client(name).defaults.headers.common[header];
                    return;
                }

                this.client(name).defaults.headers.common[header] = value;
            },
            client(name) {
                return this.clients[name || 'default'];
            },
            url(name, path) {
                return this.client(name).defaults.baseURL+path;
            },
            onUnauthorized(handler) {
                this.refreshHandler = handler;
            },
            canRefresh(options) {
                return !!this.refreshHandler
                    && !!(options.headers?.Authorization || this.client(options.name).defaults.headers.common.Authorization);
            },
            withRefreshedToken(params, token) {
                const headers = params.headers?.Authorization
                    ? {...params.headers, Authorization: 'Bearer ' + token}
                    : params.headers;

                return {...params, headers, retried: true};
            },
            parseUri(uri, params) {

                const parameters = {...app.config.globalProperties.$route.params, ...params}

                return uri.replaceAll(/:([A-Za-z][\w.]+)(\??)/g, (segment, s1, s2) => {

                    if (parameters[s1])
                        return parameters[s1] ?? '[null]';

                    if (s2 === '?')
                        return '';

                    throw Error(`Cannot find params '${segment.substr(1)}' in: ${uri}`);
                });
            },
            request(params) {
                return new Promise((resolve, reject) => {

                    const {retried, refresh = true, ...request} = params;

                    let options = {
                        ...request,
                        url: this.parseUri(request.url, request.routeParams || request.params || {})
                    };

                    if(options.params)
                        options.params = Object.clearObject(options.params)

                    this.client(options.name)
                        .request(options)
                        .then((response) => {


                            if (response.status >= 200 && response.status < 300)
                                return resolve({data: response.data, code: response.status});

                            if (response.status === 401 && refresh && !retried && this.canRefresh(options))
                                return this.refreshHandler()
                                    .then((token) => this.request(this.withRefreshedToken(params, token)))
                                    .then(resolve, reject);

                            if (response.status >= 400 && response.status < 500)
                                return reject({
                                    message: response.data.message,
                                    errors: response.data.errors ?? [],
                                    code: response.status
                                });
                        })
                        .catch((e) => {
                            reject(e);
                        })
                        .finally(() => {

                        })
                });
            }
        };

        app.config.globalProperties.$http.header('default', 'X-App-Mode', 'agent');
    }

}
